import ReactTableBase from "../../Table/ReactTableBase";
import React from "react";
import {Link} from "react-router-dom";
import styles from "../../Table/ReactTableBase.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faExternalLink} from "@fortawesome/free-solid-svg-icons";
import {ImageIllustration} from "../../Image/ImageIllustration";
import BtnSwitch from "../../Button/BtnSwitch";
import stylesSwitch from "../../Button/BtnSwitch.module.css";
import RenderCellActif from "../../Table/RenderCellActif";
import RenderCellSplit from "../../Table/RenderCellSplit";
import RenderCellBool from "../../Table/RenderCellBool";
import DateService from "../../../services/DateService";


const CrmUserOptinTable = ({ crmUserOptin, putOptin = null, serverSideSorting = false, onSortChange = null, initialSortBy = "" }) => {
    const data = React.useMemo(() => crmUserOptin, [crmUserOptin]);

    const renderCellUpdate = ({ value }) => {
        if (!DateService.isValidDate(value)) return;
        return (
            <span style={{ fontSize: "0.9rem", color: "#333" }}>{DateService.formatDate(value)}</span>
        );
    }

    const columns = [
        /*{
            Header: 'Id',
            accessor: 'id',
        },*/
        {
            Header: 'Utilisateur',
            accessor: 'user',
            Cell: ({ value }) => <Link to={`/admin/utilisateurs/${value.id}`}>{value.nom} {value.prenom}</Link>,
        },
        {
            Header: 'Cours email',
            accessor: 'cours_email',
            isBoolean: true,
            Cell: (cellInfo) => <RenderCellBool {...cellInfo} putActifSwitch={putOptin} enableLabel={"Activé"} disableLabel={"Désactivé"} />,
        },
        {
            Header: 'Cours email dernière modif',
            accessor: 'cours_email_date',
            isBoolean: true,
            Cell: renderCellUpdate,
        },
        {
            Header: 'SMS cours',
            accessor: 'cours_sms',
            isBoolean: true,
            Cell: (cellInfo) => <RenderCellBool {...cellInfo} putActifSwitch={putOptin} enableLabel={"Activé"} disableLabel={"Désactivé"} />,
        },
        {
            Header: 'SMS cours dernière modif',
            accessor: 'cours_sms_date',
            isBoolean: true,
            Cell: renderCellUpdate,
        },
        {
            Header: 'Email relance',
            accessor: 'relance_email',
            isBoolean: true,
            Cell: (cellInfo) => <RenderCellBool {...cellInfo} putActifSwitch={putOptin} enableLabel={"Activé"} disableLabel={"Désactivé"} />,
        },
        {
            Header: 'Email relance dernière modif',
            accessor: 'relance_email_date',
            isBoolean: true,
            Cell: renderCellUpdate,
        },
        {
            Header: 'SMS relance',
            accessor: 'relance_sms',
            isBoolean: true,
            Cell: (cellInfo) => <RenderCellBool {...cellInfo} putActifSwitch={putOptin} enableLabel={"Activé"} disableLabel={"Désactivé"} />,
        },
        {
            Header: 'SMS relance dernière modif',
            accessor: 'relance_sms_date',
            isBoolean: true,
            Cell: renderCellUpdate,
        },
        {
            Header: 'Dernière modif par',
            accessor: 'last_modif_by',
            Cell: ({ value }) => value ? <Link to={`/admin/utilisateurs/${value.id}`}>{value.nom} {value.prenom}</Link> : null,
        },
    ];

    return (
        <ReactTableBase
            dataSource={crmUserOptin}
            columnsData={columns}
            serverSideSorting={serverSideSorting}
            initialSortBy={initialSortBy}
            onSortChange={onSortChange}
        />
    );
}

export default CrmUserOptinTable;